import React from 'react'

const MagnifyingGlassComponent = () => {
  return (
    <div className='absolute top-0 left-0  h-full w-full   '>
    <div className='relative h-full w-full flex justify-center items-center'>
        <div className='h-full w-full absolute bg-black opacity-0  z-40 group-hover:opacity-20 transition-all duration-300 '></div>
        <img src='/images/icons/magnifying-glass-white.svg' className='absolute h-5 w-5 z-50 opacity-0 group-hover:opacity-100 transition-all duration-300 delay-300' />
    </div>
</div>

  )
}

export default MagnifyingGlassComponent